import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import React from 'react'
import { useSelector } from 'react-redux'
import { HomeCopy } from '@chegg-wt/core/types/core'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { updateMessagingFlagSelector } from '@chegg-wt/core/state/app/selectors'
import { Config } from '@chegg-wt/core/config'
import { CM } from '@chegg-wt/core/constants/site'
import { PageHeader, PageHeaderWrapper } from '../Layouts/styled'
import CardWithLink from '../CardWithLink'
import { SubHeadingBCHomePage } from '../BrandConsolidation'
import * as Styled from './styled'
import { CARDS_HEADER } from './testIds'

export interface HeaderWithCardsProps {
  copy: HomeCopy
}

export const HeaderWithCards: React.FunctionComponent<HeaderWithCardsProps> = ({
  copy,
}) => {
  const { toPlagiarism, toSourceTypeSelection } = useRoutesContext()
  const currentStyle = useSelector(currentStyleSelector)
  const updateMessagingFeatureEnabled = useSelector(updateMessagingFlagSelector)
  const { appName } = Config

  return (
    <Styled.Container data-test="header-with-cards">
      <PageHeaderWrapper>
        <PageHeader data-test={CARDS_HEADER}>{copy.header}</PageHeader>
        {(appName !== CM || updateMessagingFeatureEnabled) && <SubHeadingBCHomePage />}
      </PageHeaderWrapper>
      <Styled.CardsContainer>
        <CardWithLink
          cardProps={copy.createCitations}
          route={toSourceTypeSelection({ style: currentStyle })}
        />
        <CardWithLink cardProps={copy.checkPaper} route={toPlagiarism()} />
      </Styled.CardsContainer>
    </Styled.Container>
  )
}

export default HeaderWithCards
